import {
  AccountStarOutlineIcon,
  CalendarTodayIcon,
  ClockOutlineIcon,
  DatabaseOutlineIcon,
  PaidIcon,
  TimelineIcon,
} from 'assets/icons';

export const ORDER_STATUS = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  NEW: 'NEW',
  DONE: 'DONE',
  CANCELED: 'CANCELED',
};

export const scoringMatrixData = {
  'Customer Relationship': {
    label: 'Customer Relationship',
    icon: <AccountStarOutlineIcon />,
  },
  Urgency: {
    label: 'Urgency',
    icon: <CalendarTodayIcon />,
  },
  'Value (Revenue)': {
    label: 'Value (Revenue)',
    icon: <ClockOutlineIcon />,
  },
  'Value (Margin)': {
    label: 'Value (Margin)',
    icon: <DatabaseOutlineIcon />,
  },
  'Part Complexity': {
    label: 'Part Complexity',
    icon: <PaidIcon />,
  },
  'Part Turnaround': {
    label: 'Part Turnaround',
    icon: <TimelineIcon />,
  },
};

export const READY_TO_SHIP_TEXT_STATUS = 'Ready to Ship';

export const READY_TO_SHIP_PHASE = 'outgoing';

export const DUE_DATE = {
  ANY: 'any',
  EMPTY_DYE: 'null',
  NOT_EMPTY_DYE: 'notNull',
};

export const DEFAULT_DUE_DATE_FILTER_TITLE = 'Due Date';

export const DUE_DATE_FILTER_TITLE = {
  [DUE_DATE.ANY]: 'Any Due',
  [DUE_DATE.EMPTY_DYE]: 'Empty Due',
  [DUE_DATE.NOT_EMPTY_DYE]: 'Not Empty Due',
};

export const SORT = {
  CREATION_DATE: 'created',
  DUE_DATE: 'end_date',
  PRODUCTION_SCORE: 'score',
};

export const SORT_TITLE = {
  CREATION_DATE: 'Creation Date',
  DUE_DATE: 'Due Date',
  PRODUCTION_SCORE: 'Production Score',
};

export const SORT_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc',
};

export const EXPANDED_CARD_STORAGE_KEY = {
  customer: 'expandedCard_customer_',
  employee: 'expandedCard_employee_',
};
